import { NoTargetInfraError } from "@domain/infra/infra-errors";
import { InfraManager } from "@domain/infra/infra-manager";
import { InfrastructureConfig } from "@domain/server-config/server-config";
import { isNotNil } from "@utils/assert";
import { CognitoUser, CognitoUserPool } from "amazon-cognito-identity-js";

export class CognitoUserPoolProvider {
	private userPool: CognitoUserPool | null = null;

	constructor(private readonly infraManager: InfraManager) {
		this.infraManager.targetInfraChanged.add(this.onTargetInfraChanged.bind(this));
	}

	async changeInfrastructure(infrastructureId: string): Promise<void> {
		await this.infraManager.changeInfrastructureUsingId(infrastructureId);
	}

	getPool(): CognitoUserPool {
		if (isNotNil(this.userPool)) {
			return this.userPool;
		}
		throw new NoTargetInfraError("Cognito is not usable until a target infra is set");
	}

	generateCognitoUsersForAllInfras(email: string): { user: CognitoUser; infrastructureId: string }[] {
		return [...this.infraManager.allInfras].map(([infrastructureId, infra]) => ({
			user: new CognitoUser({
				Pool: new CognitoUserPool({
					UserPoolId: infra.cognitoUserPool.id,
					ClientId: infra.cognitoUserPool.clientId,
				}),
				Username: email,
			}),
			infrastructureId,
		}));
	}

	getUnsafePool(): CognitoUserPool | null {
		return this.userPool;
	}

	private onTargetInfraChanged(infra: InfrastructureConfig | null) {
		if (isNotNil(infra)) {
			this.userPool = isNotNil(infra)
				? new CognitoUserPool({
						UserPoolId: infra.cognitoUserPool.id,
						ClientId: infra.cognitoUserPool.clientId,
					})
				: null;
		}
	}
}
